import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FormWrapper = styled(Box)(({ theme }) => ({
    margin: '0 0 20px',

    '& .cell-label': {
        fontSize: '150%',
    },

    '& .cell-value': {
        fontSize: '200%',
    },

    '& .cell-description': {
        borderBottom: 0,
    },

    '& .form-control': {
        margin: '12px 0',
    },

    '& .form-separate-label': {
        margin: '0 0 10px',
        fontWeight: 500,
        lineHeight: 1.3,
        color: theme.palette.text.primary,
    },

    '& .form-info-message': {
        margin: '15px 0 30px',
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.error.light,
    },

    '& .form-info-message-text': {
        display: 'inline-block',
        marginLeft: '7px',
    },

    '& .MuiSelect-icon': {
        color: theme.palette.action.disabled,
    },
}));